import i18n from "i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

i18n
  .use(Backend) // завантаження JSON
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    debug: false,
    ns: ["common"],
    defaultNS: "common",
    interpolation: {
      escapeValue: false,
    },
    supportedLngs: ['uk', 'ru', 'en'],
    nonExplicitSupportedLngs: true, 
    backend: {
      loadPath: `/locales/{{lng}}/{{ns}}.json?v=${Date.now()}`,
    },
  });

export default i18n;

// import i18n from "i18next";
// import LanguageDetector from "i18next-browser-languagedetector";
// import { initReactI18next } from "react-i18next";

// i18n
//     .use(LanguageDetector)
//     .use(initReactI18next)
//     .init({
//         // we init with resources
//         resources: {
//             en: {
//                 translations:{
//                     "General": "General",
//                     "Dashboard": "Dashboard",
//                     "Default": "Default",
//                     "Project": "Project",
//                     "Ecommerce": "Ecommerce",
//                     "Education": "Education",
//                     "Widgets": "Widgets",
//                     "Chart": "Chart",
//                     "Applications": "Applications",
//                     "Project List": "Project List",
//                     "Create New": "Create New",
//                     "File Manager": "File Manager",
//                     "Add Products": "Add Products",
//                     "Category Page": "Category Page",
//                     "Product": "Product",
//                     "Product Page": "Product Page",
//                     "Product List": "Product List",
//                     "Payment Details": "Payment Details",
//                     "Order History": "Order History",
//                     "Invoices": "Invoices",
//                     "Invoice-1": "Invoice-1",
//                     "Invoice-2": "Invoice-2",
//                     "Invoice-3": "Invoice-3",
//                     "Invoice-4": "Invoice-4",
//                     "Invoice-5": "Invoice-5",
//                     "Invoice-6": "Invoice-6",
//                     "Cart": "Cart",
//                     "Wishlist": "Wishlist",
//                     "Checkout": "Checkout",
//                     "Pricing": "Pricing",
//                     "Chats": "Chats",
//                     "Users": "Users",
//                     "Letter Box": "Letter Box",
//                     "Private Chat": "Private Chat",
//                     "Group Chat": "Group Chat",
//                     "Users Profile": "Users Profile",
//                     "Users Edit": "Users Edit",
//                     "Users Cards": "Users Cards",
//                     "Bookmarks": "Bookmarks",
//                     "Contacts": "Contacts",
//                     "Tasks": "Tasks",
//                     "Calendar": "Calendar",
//                     "Social App": "Social App",
//                     "To-Do": "To-Do",
//                     "Search Result": "Search Result",
//                     "Form Validation": "Form Validation",
//                     "Base Inputs": "Base Inputs",
//                     "Checkbox & Radio": "Checkbox & Radio",
//                     "Input Groups": "Input Groups",
//                     "Input Mask": "Input Mask",
//                     "Mega Options": "Mega Options",
//                     "Datepicker": "Datepicker",
//                     "Touchspin": "Touchspin",
//                     "Switch": "Switch",
//                     "Forms": "Forms",
//                     "Form Controls": "Form Controls",
//                     "Forms & Table": "Forms & Table",
//                     "Typeahead": "Typeahead",
//                     "Clipboard": "Clipboard",
//                     "Form Widgets": "Form Widgets",
//                     "Form Wizard 1": "Form Wizard 1",
//                     "Form Wizard 2": "Form Wizard 2",
//                     "Two Factor": "Two Factor",
//                     "Form Layout": "Form Layout",
//                     "Tables": "Tables",
//                     "Reactstrap Tables": "Reactstrap Tables",
//                     "Basic Tables": "Basic Tables",
//                     "Table Components": "Table Components",
//                     "Data Tables": "Data Tables",
//                     "Basic Init": "Basic Init",
//                     "Advance Init": "Advance Init",
//                     "API": "API",
//                     "Data Sources": "Data Sources",
//                     "Components": "Components",
//                     "Typography": "Typography",
//                     "Avatars": "Avatars",
//                     "Helper Classes": "Helper Classes",
//                     "Grid": "Grid",
//                     "Tag & Pills": "Tag & Pills",
//                     "Progress": "Progress",
//                     "Modal": "Modal",
//                     "Alert": "Alert",
//                     "Popover": "Popover",
//                     "Tooltip": "Tooltip",
//                     "Ui Kits": "Ui Kits",
//                     "Dropdown": "Dropdown",
//                     "Accordion": "Accordion",
//                     "Tabs": "Tabs",
//                     "Lists": "Lists",
//                     "Divider": "Divider",
//                     "Placeholders": "Placeholders",
//                     "Offcanvas": "Offcanvas",
//                     "Navigate" :"Navigate",
//                     "Ratios": "Ratios",
//                     "Bonus Ui": "Bonus Ui",
//                     "Scrollable": "Scrollable",
//                     "Tree View": "Tree View",
//                     "Toasts": "Toasts",
//                     "Rating": "Rating",
//                     "Dropzone": "Dropzone",
//                     "Tour": "Tour",
//                     "SweetAlert2": "SweetAlert2",
//                     "Carousel": "Carousel",
//                     "Ribbons": "Ribbons",
//                     "Pagination": "Pagination",
//                     "Breadcrumb": "Breadcrumb",
//                     "Range Slider": "Range Slider",
//                     "Image Cropper": "Image Cropper",
//                     "Basic Card": "Basic Card",
//                     "Creative Card": "Creative Card",
//                     "Timeline": "Timeline",
//                     "Icons": "Icons",
//                     "Flag Icon": "Flag Icon",
//                     "Fontawesome Icon": "Fontawesome Icon",
//                     "Ico Icon": "Ico Icon",
//                     "Themify Icon": "Themify Icon",
//                     "Feather Icon": "Feather Icon",
//                     "Whether Icon": "Whether Icon",
//                     "Buttons": "Buttons",
//                     "Default Style": "Default Style",
//                     "Button Group": "Button Group",
//                     "Charts": "Charts",
//                     "Apex Chart": "Apex Chart",
//                     "Google Chart": "Google Chart",
//                     "Chartjs Chart": "Chartjs Chart",
//                     "Pages": "Pages",
//                     "Sample Page": "Sample Page",
//                     "Others": "Others",
//                     "Error Page": "Error Page",
//                     "Error 400": "Error 400",
//                     "Error 401": "Error 401",
//                     "Error 403": "Error 403",
//                     "Error 404": "Error 404",
//                     "Error 500": "Error 500",
//                     "Error 503": "Error 503",
//                     "Login Simple": "Login Simple",
//                     "Login with Bg Image": "Login with Bg Image",
//                     "Login With Image Two": "Login With Image Two",
//                     "Login With Validation": "Login With Validation",
//                     "Login With Tooltip": "Login With Tooltip",
//                     "Login With Sweetalert": "Login With Sweetalert",
//                     "Register Simple": "Register Simple",
//                     "Register With Bg Image": "Register With Bg Image",
//                     "Register With Bg Two": "Register With Bg Two",
//                     "Register Wizard": "Register Wizard",
//                     "Unlock User": "Unlock User",
//                     "Forget Password": "Forget Password",
//                     "Reset Password": "Reset Password",
//                     "Maintenance": "Maintenance",
//                     "Coming Simple": "Coming Simple",
//                     "Coming With Bg Video": "Coming With Bg Video",
//                     "Coming With Bg Image": "Coming With Bg Image",
//                     "Miscellaneous": "Miscellaneous",
//                     "Gallery": "Gallery",
//                     "Gallery Grid": "Gallery Grid",
//                     "Gallery Grid Desc": "Gallery Grid Desc",
//                     "Masonry Gallery": "Masonry Gallery",
//                     "Masonry With Desc": "Masonry With Desc",
//                     "Hover Effects": "Hover Effects",
//                     "Blog": "Blog",
//                     "Blog Grids": "Blog Grids",
//                     "Blog Details": "Blog Details",
//                     "Blog Single": "Blog Single",
//                     "Add Post": "Add Post",
//                     "FAQ": "FAQ",
//                     "Job Search": "Job Search",
//                     "Cards View": "Cards View",
//                     "List View": "List View",
//                     "Job Details": "Job Details",
//                     "Apply": "Apply",
//                     "Learning": "Learning",
//                     "Learning List": "Learning List",
//                     "Detailed Course": "Detailed Course",
//                     "Maps": "Maps",
//                     "Google Maps": "Google Maps",
//                     "Leaflet Maps": "Leaflet Maps",
//                     "Editors": "Editors",
//                     "Ck Editor": "Ck Editor",
//                     "MDE Editor": "MDE Editor",
//                     "ACE Code Editor": "ACE Code Editor",
//                     "Quill Editor": "Quill Editor",
//                     "ACE Editor": "ACE Editor",
//                     "Knowledgebase": "Knowledgebase",
//                     "Support Ticket": "Support Ticket",
//                     "Authentication": "Authentication",
//                     "Login With Bg Image": "Login With Bg Image",
//                     "Pinned": "Pinned",
//                     "Coming Soon": "Coming Soon"
//                 },               
//             },
//             cn: {
//                 translations: {
//                     "General": "通用",
//                     "Dashboard": "仪表板",
//                     "Default": "默认",
//                     "Project": "项目",
//                     "Ecommerce": "电子商务",
//                     "Education": "教育",
//                     "Widgets": "小部件",
//                     "Chart": "图表",
//                     "Applications": "应用程序",
//                     "Project List": "项目列表",
//                     "Create New": "创建新项目",
//                     "File Manager": "文件管理",
//                     "Add Products": "添加产品",
//                     "Category Page": "分类页面",
//                     "Product": "产品",
//                     "Product Page": "产品页面",
//                     "Product List": "产品列表",
//                     "Payment Details": "支付详情",
//                     "Order History": "订单历史",
//                     "Invoices": "发票",
//                     "Invoice-1": "发票-1",
//                     "Invoice-2": "发票-2",
//                     "Invoice-3": "发票-3",
//                     "Invoice-4": "发票-4",
//                     "Invoice-5": "发票-5",
//                     "Invoice-6": "发票-6",
//                     "Cart": "购物车",
//                     "Wishlist": "愿望清单",
//                     "Checkout": "结账",
//                     "Pricing": "定价",
//                     "Chats": "聊天",
//                     "Users": "用户",
//                     "Letter Box": "邮箱",
//                     "Private Chat": "私人聊天",
//                     "Group Chat": "群聊",
//                     "Users Profile": "用户资料",
//                     "Users Edit": "编辑用户",
//                     "Users Cards": "用户卡片",
//                     "Bookmarks": "书签",
//                     "Contacts": "联系人",
//                     "Tasks": "任务",
//                     "Calendar": "日历",
//                     "Social App": "社交应用",
//                     "To-Do": "待办事项",
//                     "Search Result": "搜索结果",
//                     "Form Validation": "表单验证",
//                     "Base Inputs": "基本输入",
//                     "Checkbox & Radio": "复选框和单选框",
//                     "Input Groups": "输入组",
//                     "Input Mask": "输入掩码",
//                     "Mega Options": "巨型选项",
//                     "Datepicker": "日期选择器",
//                     "Touchspin": "触摸旋转",
//                     "Switch": "开关",
//                     "Forms": "表单",
//                     "Form Controls": "表单控件",
//                     "Forms & Table": "表单和表格",
//                     "Typeahead": "自动完成",
//                     "Clipboard": "剪贴板",
//                     "Form Widgets": "表单小部件",
//                     "Form Wizard 1": "表单向导 1",
//                     "Form Wizard 2": "表单向导 2",
//                     "Two Factor": "双因素",
//                     "Form Layout": "表单布局",
//                     "Tables": "表格",
//                     "Reactstrap Tables": "Reactstrap 表格",
//                     "Basic Tables": "基础表格",
//                     "Table Components": "表格组件",
//                     "Data Tables": "数据表格",
//                     "Basic Init": "基本初始化",
//                     "Advance Init": "高级初始化",
//                     "API": "API",
//                     "Data Sources": "数据源",
//                     "Components": "组件",
//                     "Typography": "排版",
//                     "Avatars": "头像",
//                     "Helper Classes": "辅助类",
//                     "Grid": "网格",
//                     "Tag & Pills": "标签和药丸",
//                     "Progress": "进度",
//                     "Modal": "模态框",
//                     "Alert": "警报",
//                     "Popover": "弹出框",
//                     "Tooltip": "工具提示",
//                     "Ui Kits": "UI 套件",
//                     "Dropdown": "下拉菜单",
//                     "Accordion": "手风琴",
//                     "Tabs": "标签",
//                     "Lists": "列表",
//                     "Divider": "分隔线",
//                     "Placeholders": "占位符",
//                     "Offcanvas": "画布外",
//                     "Navigate": "导航",
//                     "Ratios": "比率",
//                     "Bonus Ui": "奖励 UI",
//                     "Scrollable": "可滚动",
//                     "Tree View": "树视图",
//                     "Toasts": "消息提示",
//                     "Rating": "评分",
//                     "Dropzone": "拖放区域",
//                     "Tour": "导览",
//                     "SweetAlert2": "SweetAlert2",
//                     "Carousel": "轮播",
//                     "Ribbons": "丝带",
//                     "Pagination": "分页",
//                     "Breadcrumb": "面包屑",
//                     "Range Slider": "范围滑块",
//                     "Image Cropper": "图像裁剪",
//                     "Basic Card": "基础卡片",
//                     "Creative Card": "创意卡片",
//                     "Timeline": "时间线",
//                     "Icons": "图标",
//                     "Flag Icon": "旗帜图标",
//                     "Fontawesome Icon": "Fontawesome 图标",
//                     "Ico Icon": "Ico 图标",
//                     "Themify Icon": "Themify 图标",
//                     "Feather Icon": "Feather 图标",
//                     "Whether Icon": "天气图标",
//                     "Buttons": "按钮",
//                     "Default Style": "默认样式",
//                     "Button Group": "按钮组",
//                     "Charts": "图表",
//                     "Apex Chart": "Apex 图表",
//                     "Google Chart": "Google 图表",
//                     "Chartjs Chart": "Chartjs 图表",
//                     "Pages": "页面",
//                     "Sample Page": "示例页面",
//                     "Others": "其他",
//                     "Error Page": "错误页面",
//                     "Error 400": "错误 400",
//                     "Error 401": "错误 401",
//                     "Error 403": "错误 403",
//                     "Error 404": "错误 404",
//                     "Error 500": "错误 500",
//                     "Error 503": "错误 503",
//                     "Login Simple": "简单登录",
//                     "Login with Bg Image": "背景图像登录",
//                     "Login With Image Two": "双图像登录",
//                     "Login With Validation": "验证登录",
//                     "Login With Tooltip": "提示登录",
//                     "Login With Sweetalert": "Sweetalert 登录",
//                     "Register Simple": "简单注册",
//                     "Register With Bg Image": "背景图像注册",
//                     "Register With Bg Two": "双图像注册",
//                     "Register Wizard": "注册向导",
//                     "Unlock User": "解锁用户",
//                     "Forget Password": "忘记密码",
//                     "Reset Password": "重置密码",
//                     "Maintenance": "维护",
//                     "Coming Simple": "简单即将到来",
//                     "Coming With Bg Video": "带背景视频即将到来",
//                     "Coming With Bg Image": "带背景图像即将到来",
//                     "Miscellaneous": "杂项",
//                     "Gallery": "画廊",
//                     "Gallery Grid": "画廊网格",
//                     "Gallery Grid Desc": "画廊网格描述",
//                     "Masonry Gallery": "石匠画廊",
//                     "Masonry With Desc": "带描述的石匠",
//                     "Hover Effects": "悬停效果",
//                     "Blog": "博客",
//                     "Blog Grids": "博客网格",
//                     "Blog Details": "博客详情",
//                     "Blog Single": "单一博客",
//                     "Add Post": "添加帖子",
//                     "FAQ": "常见问题",
//                     "Job Search": "工作搜索",
//                     "Cards View": "卡片视图",
//                     "List View": "列表视图",
//                     "Job Details": "工作详情",
//                     "Apply": "申请",
//                     "Learning": "学习",
//                     "Learning List": "学习列表",
//                     "Detailed Course": "详细课程",
//                     "Maps": "地图",
//                     "Google Maps": "Google 地图",
//                     "Leaflet Maps": "Leaflet 地图",
//                     "Editors": "编辑器",
//                     "Ck Editor": "CK 编辑器",
//                     "MDE Editor": "MDE 编辑器",
//                     "ACE Code Editor": "ACE 代码编辑器",
//                     "Quill Editor": "Quill 编辑器",
//                     "ACE Editor": "ACE 编辑器",
//                     "Knowledgebase": "知识库",
//                     "Support Ticket": "支持票",
//                     "Authentication": "认证",
//                     "Login With Bg Image": "背景图像登录",
//                     "Pinned": "固定",
//                     "Coming Soon": "即将到来"
//                 },
//             },
//             ae: {
//                 translations:
//                 {
//                     "General": "عامة",
//                     "Dashboard": "لوحات القيادة",
//                     "Default": "افتراضي",
//                     "Project": "مشروع",
//                     "Ecommerce": "التجارة الإلكترونية",
//                     "Education": "التعليم",
//                     "Widgets": "حاجيات",
//                     "Chart": "رسم بياني",
//                     "Applications": "تطبيقات",
//                     "Project List": "قائمة المشروع",
//                     "Create New": "إنشاء جديد",
//                     "File Manager": "مدير الملفات",
//                     "Add Products": "إضافة منتج",
//                     "Category Page": "صفحة الفئة",
//                     "Product": "منتج",
//                     "Product Page": "صفحة المنتج",
//                     "Product List": "قائمة المنتج",
//                     "Payment Details": "تفاصيل الدفع",
//                     "Order History": "تاريخ الطلب",
//                     "Invoices": "فاتورة",
//                     "Invoice-1": "فاتورة-1",
//                     "Invoice-2": "فاتورة-2",
//                     "Invoice-3": "فاتورة-3",
//                     "Invoice-4": "فاتورة-4",
//                     "Invoice-5": "فاتورة-5",
//                     "Invoice-6": "فاتورة-6",
//                     "Cart": "عربة التسوق",
//                     "Wishlist": "قائمة الرغبات",
//                     "Checkout": "السداد",
//                     "Pricing": "التسعير",
//                     "Chats": "دردشة",
//                     "Users": "المستخدمين",
//                     "Letter Box": "صندوق البريد",
//                     "Private Chat": "الدردشة الخاصة",
//                     "Group Chat": "الدردشة الجماعية",
//                     "Users Profile": "ملف المستخدم",
//                     "Users Edit": "تحرير المستخدم",
//                     "Users Cards": "بطاقات المستخدم",
//                     "Bookmarks": "الإشارات المرجعية",
//                     "Contacts": "جهات الاتصال",
//                     "Tasks": "المهمة",
//                     "Calendar": "التقويم",
//                     "Social App": "تطبيق اجتماعي",
//                     "To-Do": "قائمة المهام",
//                     "Search Result": "نتائج البحث",
//                     "Form Validation": "التحقق من النموذج",
//                     "Base Inputs": "المدخلات الأساسية",
//                     "Checkbox & Radio": "خانات الاختيار والراديو",
//                     "Input Groups": "مجموعات المدخلات",
//                     "Input Mask": "قناع المدخلات",
//                     "Mega Options": "خيار ميجا",
//                     "Datepicker": "منتقي التاريخ",
//                     "Touchspin": "اللمس الدوار",
//                     "Switch": "التبديل",
//                     "Forms": "النماذج",
//                     "Form Controls": "عناصر التحكم في النموذج",
//                     "Forms & Table": "النماذج والجداول",
//                     "Typeahead": "التنبؤ التلقائي",
//                     "Clipboard": "الحافظة",
//                     "Form Widgets": "عنصر واجهة النموذج",
//                     "Form Wizard 1": "معالج النموذج 1",
//                     "Form Wizard 2": "معالج النموذج 2",
//                     "Two Factor": "العاملين بعاملين",
//                     "Form Layout": "تخطيط النموذج",
//                     "Tables": "الجدول",
//                     "Reactstrap Tables": "جداول Reactstrap",
//                     "Basic Tables": "الجداول الأساسية",
//                     "Table Components": "مكونات الجدول",
//                     "Data Tables": "جداول البيانات",
//                     "Basic Init": "البدء الأساسي",
//                     "Advance Init": "البدء المتقدم",
//                     "API": "واجهة برمجة التطبيقات",
//                     "Data Sources": "مصدر البيانات",
//                     "Components": "المكونات",
//                     "Typography": "الأسلوب الطباعي",
//                     "Avatars": "الصور الرمزية",
//                     "Helper Classes": "فصول المساعدة",
//                     "Grid": "الشبكة",
//                     "Tag & Pills": "العلامة والأقراص",
//                     "Progress": "التقدم",
//                     "Modal": "نافذة منبثقة",
//                     "Alert": "تنبيه",
//                     "Popover": "البوب أوفر",
//                     "Tooltip": "تلميح",
//                     "Ui Kits": "مجموعات واجهة المستخدم",
//                     "Dropdown": "القائمة المنسدلة",
//                     "Accordion": "الأكورديون",
//                     "Tabs": "علامات التبويب",
//                     "Lists": "القوائم",
//                     "Divider": "فاصل",
//                     "Placeholders": "عناصر نائبة",
//                     "Offcanvas":" خارج اللوحة",
//                     "Navigate":" تنقل",
//                     "Ratios": "نسب",
//                     "Bonus Ui": "واجهة المكافآت",
//                     "Scrollable": "قابل للتمرير",
//                     "Tree View": "عرض الشجرة",
//                     "Toasts": "التنبيهات",
//                     "Rating": "التقييم",
//                     "Dropzone": "منطقة الإفلات",
//                     "Tour": "جولة",
//                     "SweetAlert2": "التنبيه الحلو 2",
//                     "Carousel": "كاروسيل",
//                     "Ribbons": "الشرائط",
//                     "Pagination": "ترقيم الصفحات",
//                     "Breadcrumb": "فتات الخبز",
//                     "Range Slider": "شريط النطاق",
//                     "Image Cropper": "أداة القص للصور",
//                     "Basic Card": "بطاقة أساسية",
//                     "Creative Card": "بطاقة إبداعية",
//                     "Timeline": "الجدول الزمني",
//                     "Icons": "الأيقونات",
//                     "Flag Icon": "أيقونة العلم",
//                     "Fontawesome Icon": "أيقونة Fontawesome",
//                     "Ico Icon": "أيقونة Ico",
//                     "Themify Icon": "أيقونة Themify",
//                     "Feather Icon": "أيقونة Feather",
//                     "Whether Icon": "أيقونة الطقس",
//                     "Buttons": "أزرار",
//                     "Default Style": "أسلوب إفتراضي",
//                     "Button Group": "مجموعة الأزرار",
//                     "Charts": "الرسوم البيانية",
//                     "Apex Chart": "رسم بياني Apex",
//                     "Google Chart": "رسم بياني Google",
//                     "Chartjs Chart": "رسم بياني Chart JS",
//                     "Pages": "الصفحات",
//                     "Sample Page": "صفحة عينة",
//                     "Others": "أخرى",
//                     "Error Page": "صفحات الخطأ",
//                     "Error 400": "خطأ 400",
//                     "Error 401": "خطأ 401",
//                     "Error 403": "خطأ 403",
//                     "Error 404": "خطأ 404",
//                     "Error 500": "خطأ 500",
//                     "Error 503": "خطأ 503",
//                     "Login Simple": "تسجيل الدخول البسيط",
//                     "Login with Bg Image": "تسجيل الدخول مع صورة الخلفية",
//                     "Login With Image Two": "تسجيل الدخول مع صورتين",
//                     "Login With Validation": "تسجيل الدخول مع التحقق",
//                     "Login With Tooltip": "تسجيل الدخول مع تلميح",
//                     "Login With Sweetalert": "تسجيل الدخول مع تنبيه Sweetalert",
//                     "Register Simple": "التسجيل البسيط",
//                     "Register With Bg Image": "التسجيل مع صورة الخلفية",
//                     "Register With Bg Two": "التسجيل مع صورتين",
//                     "Register Wizard": "معالج التسجيل",
//                     "Unlock User": "فتح المستخدم",
//                     "Forget Password": "نسيت كلمة المرور",
//                     "Reset Password": "إعادة تعيين كلمة المرور",
//                     "Maintenance": "الصيانة",
//                     "Coming Simple": "قريبًا بسيط",
//                     "Coming With Bg Video": "قريبًا مع فيديو الخلفية",
//                     "Coming With Bg Image": "قريبًا مع صورة الخلفية",
//                     "Miscellaneous": "متنوع",
//                     "Gallery": "المعرض",
//                     "Gallery Grid": "شبكات المعرض",
//                     "Gallery Grid Desc": "وصف الشبكة في المعرض",
//                     "Masonry Gallery": "معرض الطوب",
//                     "Masonry With Desc": "مع الوصف",
//                     "Hover Effects": "تأثير التحويم",
//                     "Blog": "المدونة",
//                     "Blog Grids": "شبكات المدونة",
//                     "Blog Details": "تفاصيل المدونة",
//                     "Blog Single": "مدونة فردية",
//                     "Add Post": "إضافة منشور",
//                     "FAQ": "الأسئلة الشائعة",
//                     "Job Search": "بحث عن وظيفة",
//                     "Cards View": "عرض البطاقات",
//                     "List View": "عرض القائمة",
//                     "Job Details": "تفاصيل الوظيفة",
//                     "Apply": "تقديم الطلب",
//                     "Learning": "التعلم",
//                     "Learning List": "قائمة التعلم",
//                     "Detailed Course": "دورة مفصلة",
//                     "Maps": "الخريطة",
//                     "Google Maps": "الخريطة من Google",
//                     "Leaflet Maps": "الخريطة من Leaflet",
//                     "Editors": "المحرر",
//                     "Ck Editor": "محرر سي كيه",
//                     "MDE Editor": "محرر MDE",
//                     "ACE Code Editor": "محرر كود ACE",
//                     "Quill Editor": "محرر Quill",
//                     "ACE Editor": "محرر ACE",
//                     "Knowledgebase": "قاعدة المعرفة",
//                     "Support Ticket": "تذكرة الدعم",
//                     "Authentication": "المصادقة",
//                     "Login With Bg Image": "تسجيل الدخول مع صورة خلفية",
//                     "Pinned": "مثبت",
//                     "Coming Soon": "قريبًا"
//                 },
//             },
//             du: {
//                 translations: {
//                     "General": "Allgemein",
//                     "Dashboard": "Armaturenbrett",
//                     "Default": "Standard",
//                     "Project": "Projekt",
//                     "Ecommerce": "E-Commerce",
//                     "Education": "Bildung",
//                     "Widgets": "Widgets",
//                     "Chart": "Diagramm",
//                     "Applications": "Anwendungen",
//                     "Project List": "Projektliste",
//                     "Create New": "Neu erstellen",
//                     "File Manager": "Dateimanager",
//                     "Add Products": "Produkte hinzufügen",
//                     "Category Page": "Kategorieseite",
//                     "Product": "Produkt",
//                     "Product Page": "Produktseite",
//                     "Product List": "Produktliste",
//                     "Payment Details": "Zahlungsdetails",
//                     "Order History": "Bestellverlauf",
//                     "Invoices": "Rechnungen",
//                     "Invoice-1": "Rechnung-1",
//                     "Invoice-2": "Rechnung-2",
//                     "Invoice-3": "Rechnung-3",
//                     "Invoice-4": "Rechnung-4",
//                     "Invoice-5": "Rechnung-5",
//                     "Invoice-6": "Rechnung-6",
//                     "Cart": "Warenkorb",
//                     "Wishlist": "Wunschliste",
//                     "Checkout": "Kasse",
//                     "Pricing": "Preise",
//                     "Chats": "Chats",
//                     "Users": "Benutzer",
//                     "Letter Box": "Briefkasten",
//                     "Private Chat": "Privater Chat",
//                     "Group Chat": "Gruppenchat",
//                     "Users Profile": "Benutzerprofil",
//                     "Users Edit": "Benutzer bearbeiten",
//                     "Users Cards": "Benutzerkarten",
//                     "Bookmarks": "Lesezeichen",
//                     "Contacts": "Kontakte",
//                     "Tasks": "Aufgaben",
//                     "Calendar": "Kalender",
//                     "Social App": "Soziale App",
//                     "To-Do": "Aufgabenliste",
//                     "Search Result": "Suchergebnis",
//                     "Form Validation": "Formularvalidierung",
//                     "Base Inputs": "Grundeingaben",
//                     "Checkbox & Radio": "Kontrollkästchen und Radio",
//                     "Input Groups": "Eingabegruppen",
//                     "Input Mask": "Eingabemaske",
//                     "Mega Options": "Mega-Optionen",
//                     "Datepicker": "Datumsauswahl",
//                     "Touchspin": "Touchspin",
//                     "Switch": "Schalter",
//                     "Forms": "Formulare",
//                     "Form Controls": "Formularsteuerungen",
//                     "Forms & Table": "Formulare und Tabellen",
//                     "Typeahead": "Typeahead",
//                     "Clipboard": "Zwischenablage",
//                     "Form Widgets": "Formular-Widgets",
//                     "Form Wizard 1": "Formular-Assistent 1",
//                     "Form Wizard 2": "Formular-Assistent 2",
//                     "Two Factor": "Zwei-Faktor",
//                     "Form Layout": "Formularlayout",
//                     "Tables": "Tabellen",
//                     "Reactstrap Tables": "Reactstrap-Tabellen",
//                     "Basic Tables": "Grundtabellen",
//                     "Table Components": "Tabellenkomponenten",
//                     "Data Tables": "Datentabellen",
//                     "Basic Init": "Grundinitialisierung",
//                     "Advance Init": "Erweiterte Initialisierung",
//                     "API": "API",
//                     "Data Sources": "Datenquellen",
//                     "Components": "Komponenten",
//                     "Typography": "Typografie",
//                     "Avatars": "Avatare",
//                     "Helper Classes": "Hilfsklassen",
//                     "Grid": "Raster",
//                     "Tag & Pills": "Tags und Pillen",
//                     "Progress": "Fortschritt",
//                     "Modal": "Modal",
//                     "Alert": "Alarm",
//                     "Popover": "Popover",
//                     "Tooltip": "Tooltip",
//                     "Ui Kits": "UI-Kits",
//                     "Dropdown": "Dropdown",
//                     "Accordion": "Akkordeon",
//                     "Tabs": "Tabs",
//                     "Lists": "Listen",
//                     "Divider": "Trennlinie",
//                     "Placeholders": "Platzhalter",
//                     "Offcanvas": "Off-Canvas",
//                     "Navigate": "Navigieren",
//                     "Ratios": "Verhältnisse",
//                     "Bonus Ui": "Bonus-UI",
//                     "Scrollable": "Scrollbar",
//                     "Tree View": "Baumansicht",
//                     "Toasts": "Toasts",
//                     "Rating": "Bewertung",
//                     "Dropzone": "Dropzone",
//                     "Tour": "Tour",
//                     "SweetAlert2": "SweetAlert2",
//                     "Carousel": "Karussell",
//                     "Ribbons": "Bänder",
//                     "Pagination": "Seitennummerierung",
//                     "Breadcrumb": "Breadcrumb",
//                     "Range Slider": "Bereichsschieberegler",
//                     "Image Cropper": "Bildschneider",
//                     "Basic Card": "Grundkarte",
//                     "Creative Card": "Kreative Karte",
//                     "Timeline": "Zeitachse",
//                     "Icons": "Symbole",
//                     "Flag Icon": "Flaggensymbol",
//                     "Fontawesome Icon": "Fontawesome-Symbol",
//                     "Ico Icon": "Ico-Symbol",
//                     "Themify Icon": "Themify-Symbol",
//                     "Feather Icon": "Feather-Symbol",
//                     "Whether Icon": "Wetter-Symbol",
//                     "Buttons": "Schaltflächen",
//                     "Default Style": "Standardstil",
//                     "Button Group": "Schaltflächengruppe",
//                     "Charts": "Diagramme",
//                     "Apex Chart": "Apex-Diagramm",
//                     "Google Chart": "Google-Diagramm",
//                     "Chartjs Chart": "Chartjs-Diagramm",
//                     "Pages": "Seiten",
//                     "Sample Page": "Beispielseite",
//                     "Others": "Andere",
//                     "Error Page": "Fehlerseite",
//                     "Error 400": "Fehler 400",
//                     "Error 401": "Fehler 401",
//                     "Error 403": "Fehler 403",
//                     "Error 404": "Fehler 404",
//                     "Error 500": "Fehler 500",
//                     "Error 503": "Fehler 503",
//                     "Login Simple": "Einfache Anmeldung",
//                     "Login with Bg Image": "Anmeldung mit Hintergrundbild",
//                     "Login With Image Two": "Anmeldung mit zwei Bildern",
//                     "Login With Validation": "Anmeldung mit Validierung",
//                     "Login With Tooltip": "Anmeldung mit Tooltip",
//                     "Login With Sweetalert": "Anmeldung mit Sweetalert",
//                     "Register Simple": "Einfache Registrierung",
//                     "Register With Bg Image": "Registrierung mit Hintergrundbild",
//                     "Register With Bg Two": "Registrierung mit zwei Bildern",
//                     "Register Wizard": "Registrierungsassistent",
//                     "Unlock User": "Benutzer entsperren",
//                     "Forget Password": "Passwort vergessen",
//                     "Reset Password": "Passwort zurücksetzen",
//                     "Maintenance": "Wartung",
//                     "Coming Simple": "Einfach kommend",
//                     "Coming With Bg Video": "Kommt mit Hintergrundvideo",
//                     "Coming With Bg Image": "Kommt mit Hintergrundbild",
//                     "Miscellaneous": "Sonstiges",
//                     "Gallery": "Galerie",
//                     "Gallery Grid": "Galerieraster",
//                     "Gallery Grid Desc": "Galerierasterbeschreibung",
//                     "Masonry Gallery": "Mauerwerksgalerie",
//                     "Masonry With Desc": "Mauerwerk mit Beschreibung",
//                     "Hover Effects": "Hover-Effekte",
//                     "Blog": "Blog",
//                     "Blog Grids": "Blog-Raster",
//                     "Blog Details": "Blog-Details",
//                     "Blog Single": "Einzelblog",
//                     "Add Post": "Beitrag hinzufügen",
//                     "FAQ": "Häufig gestellte Fragen",
//                     "Job Search": "Jobsuche",
//                     "Cards View": "Kartenansicht",
//                     "List View": "Listenansicht",
//                     "Job Details": "Jobdetails",
//                     "Apply": "Bewerben",
//                     "Learning": "Lernen",
//                     "Learning List": "Lernliste",
//                     "Detailed Course": "Detaillierter Kurs",
//                     "Maps": "Karten",
//                     "Google Maps": "Google-Karten",
//                     "Leaflet Maps": "Leaflet-Karten",
//                     "Editors": "Editoren",
//                     "Ck Editor": "CK-Editor",
//                     "MDE Editor": "MDE-Editor",
//                     "ACE Code Editor": "ACE-Code-Editor",
//                     "Quill Editor": "Quill-Editor",
//                     "ACE Editor": "ACE-Editor",
//                     "Knowledgebase": "Wissensdatenbank",
//                     "Support Ticket": "Support-Ticket",
//                     "Authentication": "Authentifizierung",
//                     "Login With Bg Image": "Anmeldung mit Hintergrundbild",
//                     "Pinned": "Angeheftet",
//                     "Coming Soon": "Demnächst"
//                 },                
//             },
//             es: {
//                 translations: {
//                     "General": "General",
//                     "Dashboard": "Tablero",
//                     "Default": "Predeterminado",
//                     "Project": "Proyecto",
//                     "Ecommerce": "Comercio Electrónico",
//                     "Education": "Educación",
//                     "Widgets": "Widgets",
//                     "Chart": "Gráfico",
//                     "Applications": "Aplicaciones",
//                     "Project List": "Lista de Proyectos",
//                     "Create New": "Crear Nuevo",
//                     "File Manager": "Administrador de Archivos",
//                     "Add Products": "Agregar Productos",
//                     "Category Page": "Página de Categoría",
//                     "Product": "Producto",
//                     "Product Page": "Página del Producto",
//                     "Product List": "Lista de Productos",
//                     "Payment Details": "Detalles del Pago",
//                     "Order History": "Historial de Pedidos",
//                     "Invoices": "Facturas",
//                     "Invoice-1": "Factura-1",
//                     "Invoice-2": "Factura-2",
//                     "Invoice-3": "Factura-3",
//                     "Invoice-4": "Factura-4",
//                     "Invoice-5": "Factura-5",
//                     "Invoice-6": "Factura-6",
//                     "Cart": "Carrito",
//                     "Wishlist": "Lista de Deseos",
//                     "Checkout": "Pagar",
//                     "Pricing": "Precios",
//                     "Chats": "Chats",
//                     "Users": "Usuarios",
//                     "Letter Box": "Buzón",
//                     "Private Chat": "Chat Privado",
//                     "Group Chat": "Chat de Grupo",
//                     "Users Profile": "Perfil de Usuario",
//                     "Users Edit": "Editar Usuario",
//                     "Users Cards": "Tarjetas de Usuario",
//                     "Bookmarks": "Marcadores",
//                     "Contacts": "Contactos",
//                     "Tasks": "Tareas",
//                     "Calendar": "Calendario",
//                     "Social App": "Aplicación Social",
//                     "To-Do": "Lista de Tareas",
//                     "Search Result": "Resultado de Búsqueda",
//                     "Form Validation": "Validación de Formularios",
//                     "Base Inputs": "Entradas Básicas",
//                     "Checkbox & Radio": "Checkbox y Radio",
//                     "Input Groups": "Grupos de Entrada",
//                     "Input Mask": "Máscara de Entrada",
//                     "Mega Options": "Opciones Mega",
//                     "Datepicker": "Selector de Fecha",
//                     "Touchspin": "Touchspin",
//                     "Switch": "Interruptor",
//                     "Forms": "Formularios",
//                     "Form Controls": "Controles de Formularios",
//                     "Forms & Table": "Formularios y Tabla",
//                     "Typeahead": "Typeahead",
//                     "Clipboard": "Portapapeles",
//                     "Form Widgets": "Widgets de Formularios",
//                     "Form Wizard 1": "Asistente de Formularios 1",
//                     "Form Wizard 2": "Asistente de Formularios 2",
//                     "Two Factor": "Dos Factores",
//                     "Form Layout": "Diseño de Formularios",
//                     "Tables": "Tablas",
//                     "Reactstrap Tables": "Tablas de Reactstrap",
//                     "Basic Tables": "Tablas Básicas",
//                     "Table Components": "Componentes de Tablas",
//                     "Data Tables": "Tablas de Datos",
//                     "Basic Init": "Inicialización Básica",
//                     "Advance Init": "Inicialización Avanzada",
//                     "API": "API",
//                     "Data Sources": "Fuentes de Datos",
//                     "Components": "Componentes",
//                     "Typography": "Tipografía",
//                     "Avatars": "Avatares",
//                     "Helper Classes": "Clases de Ayuda",
//                     "Grid": "Cuadrícula",
//                     "Tag & Pills": "Etiquetas y Píldoras",
//                     "Progress": "Progreso",
//                     "Modal": "Modal",
//                     "Alert": "Alerta",
//                     "Popover": "Popover",
//                     "Tooltip": "Tooltip",
//                     "Ui Kits": "Kits de UI",
//                     "Dropdown": "Desplegable",
//                     "Accordion": "Acordeón",
//                     "Tabs": "Pestañas",
//                     "Lists": "Listas",
//                     "Divider": "Separador",
//                     "Placeholders": "Marcadores de posición",
//                     "Offcanvas": "Fuera del lienzo",
//                     "Navigate": "Navegar",
//                     "Ratios": "Proporciones",
//                     "Bonus Ui": "UI de Bonificación",
//                     "Scrollable": "Desplazable",
//                     "Tree View": "Vista de Árbol",
//                     "Toasts": "Notificaciones",
//                     "Rating": "Calificación",
//                     "Dropzone": "Zona de Descarga",
//                     "Tour": "Tour",
//                     "SweetAlert2": "SweetAlert2",
//                     "Carousel": "Carrusel",
//                     "Ribbons": "Cintas",
//                     "Pagination": "Paginación",
//                     "Breadcrumb": "Migas de Pan",
//                     "Range Slider": "Control Deslizante de Rango",
//                     "Image Cropper": "Recortador de Imágenes",
//                     "Basic Card": "Tarjeta Básica",
//                     "Creative Card": "Tarjeta Creativa",
//                     "Timeline": "Cronología",
//                     "Icons": "Iconos",
//                     "Flag Icon": "Icono de Bandera",
//                     "Fontawesome Icon": "Icono de Fontawesome",
//                     "Ico Icon": "Icono de Ico",
//                     "Themify Icon": "Icono de Themify",
//                     "Feather Icon": "Icono de Feather",
//                     "Whether Icon": "Icono de Clima",
//                     "Buttons": "Botones",
//                     "Default Style": "Estilo Predeterminado",
//                     "Button Group": "Grupo de Botones",
//                     "Charts": "Gráficos",
//                     "Apex Chart": "Gráfico de Apex",
//                     "Google Chart": "Gráfico de Google",
//                     "Chartjs Chart": "Gráfico de Chartjs",
//                     "Pages": "Páginas",
//                     "Sample Page": "Página de Muestra",
//                     "Others": "Otros",
//                     "Error Page": "Página de Error",
//                     "Error 400": "Error 400",
//                     "Error 401": "Error 401",
//                     "Error 403": "Error 403",
//                     "Error 404": "Error 404",
//                     "Error 500": "Error 500",
//                     "Error 503": "Error 503",
//                     "Login Simple": "Inicio de Sesión Simple",
//                     "Login with Bg Image": "Inicio de Sesión con Imagen de Fondo",
//                     "Login With Image Two": "Inicio de Sesión con Dos Imágenes",
//                     "Login With Validation": "Inicio de Sesión con Validación",
//                     "Login With Tooltip": "Inicio de Sesión con Tooltip",
//                     "Login With Sweetalert": "Inicio de Sesión con Sweetalert",
//                     "Register Simple": "Registro Simple",
//                     "Register With Bg Image": "Registro con Imagen de Fondo",
//                     "Register With Bg Two": "Registro con Dos Imágenes",
//                     "Register Wizard": "Asistente de Registro",
//                     "Unlock User": "Desbloquear Usuario",
//                     "Forget Password": "Olvidar Contraseña",
//                     "Reset Password": "Restablecer Contraseña",
//                     "Maintenance": "Mantenimiento",
//                     "Coming Simple": "Próximamente Simple",
//                     "Coming With Bg Video": "Próximamente con Video de Fondo",
//                     "Coming With Bg Image": "Próximamente con Imagen de Fondo",
//                     "Miscellaneous": "Misceláneo",
//                     "Gallery": "Galería",
//                     "Gallery Grid": "Cuadrícula de Galería",
//                     "Gallery Grid Desc": "Descripción de Cuadrícula de Galería",
//                     "Masonry Gallery": "Galería de Albañilería",
//                     "Masonry With Desc": "Albañilería con Descripción",
//                     "Hover Effects": "Efectos Hover",
//                     "Blog": "Blog",
//                     "Blog Grids": "Cuadrículas de Blog",
//                     "Blog Details": "Detalles del Blog",
//                     "Blog Single": "Blog Único",
//                     "Add Post": "Agregar Publicación",
//                     "FAQ": "Preguntas Frecuentes",
//                     "Job Search": "Búsqueda de Trabajo",
//                     "Cards View": "Vista de Tarjetas",
//                     "List View": "Vista de Lista",
//                     "Job Details": "Detalles del Trabajo",
//                     "Apply": "Aplicar",
//                     "Learning": "Aprendizaje",
//                     "Learning List": "Lista de Aprendizaje",
//                     "Detailed Course": "Curso Detallado",
//                     "Maps": "Mapas",
//                     "Google Maps": "Mapas de Google",
//                     "Leaflet Maps": "Mapas de Leaflet",
//                     "Editors": "Editores",
//                     "Ck Editor": "Editor CK",
//                     "MDE Editor": "Editor MDE",
//                     "ACE Code Editor": "Editor de Código ACE",
//                     "Quill Editor": "Editor Quill",
//                     "ACE Editor": "Editor ACE",
//                     "Knowledgebase": "Base de Conocimientos",
//                     "Support Ticket": "Ticket de Soporte",
//                     "Authentication": "Autenticación",
//                     "Login With Bg Image": "Inicio de Sesión con Imagen de Fondo",
//                     "Pinned": "Anclado",
//                     "Coming Soon": "Próximamente"
//                 },                
//             },
//             fr: {
//                 translations: {
//                     "General": "Général",
//                     "Dashboard": "Tableau de bord",
//                     "Default": "Par défaut",
//                     "Project": "Projet",
//                     "Ecommerce": "Commerce électronique",
//                     "Education": "Éducation",
//                     "Widgets": "Widgets",
//                     "Chart": "Graphique",
//                     "Applications": "Applications",
//                     "Project List": "Liste de projets",
//                     "Create New": "Créer nouveau",
//                     "File Manager": "Gestionnaire de fichiers",
//                     "Add Products": "Ajouter des produits",
//                     "Category Page": "Page de catégorie",
//                     "Product": "Produit",
//                     "Product Page": "Page de produit",
//                     "Product List": "Liste de produits",
//                     "Payment Details": "Détails du paiement",
//                     "Order History": "Historique des commandes",
//                     "Invoices": "Factures",
//                     "Invoice-1": "Facture-1",
//                     "Invoice-2": "Facture-2",
//                     "Invoice-3": "Facture-3",
//                     "Invoice-4": "Facture-4",
//                     "Invoice-5": "Facture-5",
//                     "Invoice-6": "Facture-6",
//                     "Cart": "Panier",
//                     "Wishlist": "Liste de souhaits",
//                     "Checkout": "Paiement",
//                     "Pricing": "Tarification",
//                     "Chats": "Chats",
//                     "Users": "Utilisateurs",
//                     "Letter Box": "Boîte aux lettres",
//                     "Private Chat": "Chat privé",
//                     "Group Chat": "Chat de groupe",
//                     "Users Profile": "Profil d'utilisateur",
//                     "Users Edit": "Modifier l'utilisateur",
//                     "Users Cards": "Cartes d'utilisateur",
//                     "Bookmarks": "Signets",
//                     "Contacts": "Contacts",
//                     "Tasks": "Tâches",
//                     "Calendar": "Calendrier",
//                     "Social App": "Application sociale",
//                     "To-Do": "Liste de tâches",
//                     "Search Result": "Résultat de la recherche",
//                     "Form Validation": "Validation de formulaire",
//                     "Base Inputs": "Entrées de base",
//                     "Checkbox & Radio": "Case à cocher et Radio",
//                     "Input Groups": "Groupes d'entrée",
//                     "Input Mask": "Masque de saisie",
//                     "Mega Options": "Options Mega",
//                     "Datepicker": "Sélecteur de date",
//                     "Touchspin": "Touchspin",
//                     "Switch": "Commutateur",
//                     "Forms": "Formulaires",
//                     "Form Controls": "Contrôles de formulaire",
//                     "Forms & Table": "Formulaires et tableau",
//                     "Typeahead": "Typeahead",
//                     "Clipboard": "Presse-papiers",
//                     "Form Widgets": "Widgets de formulaire",
//                     "Form Wizard 1": "Assistant de formulaire 1",
//                     "Form Wizard 2": "Assistant de formulaire 2",
//                     "Two Factor": "Double facteur",
//                     "Form Layout": "Disposition du formulaire",
//                     "Tables": "Tables",
//                     "Reactstrap Tables": "Tables Reactstrap",
//                     "Basic Tables": "Tables de base",
//                     "Table Components": "Composants de tableau",
//                     "Data Tables": "Tables de données",
//                     "Basic Init": "Initialisation de base",
//                     "Advance Init": "Initialisation avancée",
//                     "API": "API",
//                     "Data Sources": "Sources de données",
//                     "Components": "Composants",
//                     "Typography": "Typographie",
//                     "Avatars": "Avatars",
//                     "Helper Classes": "Classes d'aide",
//                     "Grid": "Grille",
//                     "Tag & Pills": "Tag & Pilules",
//                     "Progress": "Progression",
//                     "Modal": "Modal",
//                     "Alert": "Alerte",
//                     "Popover": "Popover",
//                     "Tooltip": "Info-bulle",
//                     "Ui Kits": "Kits d'interface utilisateur",
//                     "Dropdown": "Menu déroulant",
//                     "Accordion": "Accordéon",
//                     "Tabs": "Onglets",
//                     "Lists": "Listes",
//                     "Divider": "Séparateur",
//                     "Placeholders": "Espaces réservés",
//                     "Offcanvas": "Hors toile",
//                     "Navigate": "Naviguer",
//                     "Ratios": "Ratios",
//                     "Bonus Ui": "UI bonus",
//                     "Scrollable": "Défilable",
//                     "Tree View": "Vue arborescente",
//                     "Toasts": "Toasts",
//                     "Rating": "Évaluation",
//                     "Dropzone": "Zone de dépôt",
//                     "Tour": "Tour",
//                     "SweetAlert2": "SweetAlert2",
//                     "Carousel": "Carrousel",
//                     "Ribbons": "Rubans",
//                     "Pagination": "Pagination",
//                     "Breadcrumb": "Fil d'Ariane",
//                     "Range Slider": "Curseur de plage",
//                     "Image Cropper": "Recadrage d'image",
//                     "Basic Card": "Carte de base",
//                     "Creative Card": "Carte créative",
//                     "Timeline": "Chronologie",
//                     "Icons": "Icônes",
//                     "Flag Icon": "Icône de drapeau",
//                     "Fontawesome Icon": "Icône Fontawesome",
//                     "Ico Icon": "Icône Ico",
//                     "Themify Icon": "Icône Themify",
//                     "Feather Icon": "Icône Feather",
//                     "Whether Icon": "Icône Météo",
//                     "Buttons": "Boutons",
//                     "Default Style": "Style par défaut",
//                     "Button Group": "Groupe de boutons",
//                     "Charts": "Graphiques",
//                     "Apex Chart": "Graphique Apex",
//                     "Google Chart": "Graphique Google",
//                     "Chartjs Chart": "Graphique Chartjs",
//                     "Pages": "Pages",
//                     "Sample Page": "Page d'échantillon",
//                     "Others": "Autres",
//                     "Error Page": "Page d'erreur",
//                     "Error 400": "Erreur 400",
//                     "Error 401": "Erreur 401",
//                     "Error 403": "Erreur 403",
//                     "Error 404": "Erreur 404",
//                     "Error 500": "Erreur 500",
//                     "Error 503": "Erreur 503",
//                     "Login Simple": "Connexion simple",
//                     "Login with Bg Image": "Connexion avec image de fond",
//                     "Login With Image Two": "Connexion avec deux images",
//                     "Login With Validation": "Connexion avec validation",
//                     "Login With Tooltip": "Connexion avec info-bulle",
//                     "Login With Sweetalert": "Connexion avec Sweetalert",
//                     "Register Simple": "Inscription simple",
//                     "Register With Bg Image": "Inscription avec image de fond",
//                     "Register With Bg Two": "Inscription avec deux images",
//                     "Register Wizard": "Assistant d'inscription",
//                     "Unlock User": "Débloquer l'utilisateur",
//                     "Forget Password": "Mot de passe oublié",
//                     "Reset Password": "Réinitialiser le mot de passe",
//                     "Maintenance": "Maintenance",
//                     "Coming Simple": "À venir simple",
//                     "Coming With Bg Video": "À venir avec vidéo de fond",
//                     "Coming With Bg Image": "À venir avec image de fond",
//                     "Miscellaneous": "Divers",
//                     "Gallery": "Galerie",
//                     "Gallery Grid": "Grille de galerie",
//                     "Gallery Grid Desc": "Description de la grille de galerie",
//                     "Masonry Gallery": "Galerie en maçonnerie",
//                     "Masonry With Desc": "Maçonnerie avec description",
//                     "Hover Effects": "Effets de survol",
//                     "Blog": "Blog",
//                     "Blog Grids": "Grilles de blog",
//                     "Blog Details": "Détails du blog",
//                     "Blog Single": "Blog unique",
//                     "Add Post": "Ajouter un post",
//                     "FAQ": "FAQ",
//                     "Job Search": "Recherche d'emploi",
//                     "Cards View": "Vue des cartes",
//                     "List View": "Vue de liste",
//                     "Job Details": "Détails de l'emploi",
//                     "Apply": "Appliquer",
//                     "Learning": "Apprentissage",
//                     "Learning List": "Liste d'apprentissage",
//                     "Detailed Course": "Cours détaillé",
//                     "Maps": "Cartes",
//                     "Google Maps": "Google Maps",
//                     "Leaflet Maps": "Leaflet Maps",
//                     "Editors": "Éditeurs",
//                     "Ck Editor": "Éditeur CK",
//                     "MDE Editor": "Éditeur MDE",
//                     "ACE Code Editor": "Éditeur de code ACE",
//                     "Quill Editor": "Éditeur Quill",
//                     "ACE Editor": "Éditeur ACE",
//                     "Knowledgebase": "Base de connaissances",
//                     "Support Ticket": "Ticket de support",
//                     "Authentication": "Authentification",
//                     "Login With Bg Image": "Connexion avec image de fond",
//                     "Pinned": "Épinglé",
//                     "Coming Soon": "Prochainement"
//                 },                
//             },
//             pt: {
//                 translations: {
//                     "General": "Geral",
//                     "Dashboard": "Painel de Controle",
//                     "Default": "Padrão",
//                     "Project": "Projeto",
//                     "Ecommerce": "Comércio Eletrônico",
//                     "Education": "Educação",
//                     "Widgets": "Widgets",
//                     "Chart": "Gráfico",
//                     "Applications": "Aplicações",
//                     "Project List": "Lista de Projetos",
//                     "Create New": "Criar Novo",
//                     "File Manager": "Gerenciador de Arquivos",
//                     "Add Products": "Adicionar Produtos",
//                     "Category Page": "Página de Categoria",
//                     "Product": "Produto",
//                     "Product Page": "Página do Produto",
//                     "Product List": "Lista de Produtos",
//                     "Payment Details": "Detalhes de Pagamento",
//                     "Order History": "Histórico de Pedidos",
//                     "Invoices": "Faturas",
//                     "Invoice-1": "Fatura-1",
//                     "Invoice-2": "Fatura-2",
//                     "Invoice-3": "Fatura-3",
//                     "Invoice-4": "Fatura-4",
//                     "Invoice-5": "Fatura-5",
//                     "Invoice-6": "Fatura-6",
//                     "Cart": "Carrinho",
//                     "Wishlist": "Lista de Desejos",
//                     "Checkout": "Finalizar Compra",
//                     "Pricing": "Preços",
//                     "Chats": "Chats",
//                     "Users": "Usuários",
//                     "Letter Box": "Caixa de Correio",
//                     "Private Chat": "Chat Privado",
//                     "Group Chat": "Chat em Grupo",
//                     "Users Profile": "Perfil de Usuário",
//                     "Users Edit": "Editar Usuário",
//                     "Users Cards": "Cartões de Usuário",
//                     "Bookmarks": "Marcadores",
//                     "Contacts": "Contatos",
//                     "Tasks": "Tarefas",
//                     "Calendar": "Calendário",
//                     "Social App": "Aplicativo Social",
//                     "To-Do": "Lista de Tarefas",
//                     "Search Result": "Resultado da Busca",
//                     "Form Validation": "Validação de Formulário",
//                     "Base Inputs": "Entradas Básicas",
//                     "Checkbox & Radio": "Checkbox e Radio",
//                     "Input Groups": "Grupos de Entrada",
//                     "Input Mask": "Máscara de Entrada",
//                     "Mega Options": "Opções Mega",
//                     "Datepicker": "Selecionador de Data",
//                     "Touchspin": "Touchspin",
//                     "Switch": "Interruptor",
//                     "Forms": "Formulários",
//                     "Form Controls": "Controles de Formulário",
//                     "Forms & Table": "Formulários e Tabelas",
//                     "Typeahead": "Typeahead",
//                     "Clipboard": "Clipboard",
//                     "Form Widgets": "Widgets de Formulário",
//                     "Form Wizard 1": "Assistente de Formulário 1",
//                     "Form Wizard 2": "Assistente de Formulário 2",
//                     "Two Factor": "Dois Fatores",
//                     "Form Layout": "Layout de Formulário",
//                     "Tables": "Tabelas",
//                     "Reactstrap Tables": "Tabelas Reactstrap",
//                     "Basic Tables": "Tabelas Básicas",
//                     "Table Components": "Componentes de Tabela",
//                     "Data Tables": "Tabelas de Dados",
//                     "Basic Init": "Inicialização Básica",
//                     "Advance Init": "Inicialização Avançada",
//                     "API": "API",
//                     "Data Sources": "Fontes de Dados",
//                     "Components": "Componentes",
//                     "Typography": "Tipografia",
//                     "Avatars": "Avatares",
//                     "Helper Classes": "Classes Auxiliares",
//                     "Grid": "Grade",
//                     "Tag & Pills": "Tag & Pills",
//                     "Progress": "Progresso",
//                     "Modal": "Modal",
//                     "Alert": "Alerta",
//                     "Popover": "Popover",
//                     "Tooltip": "Tooltip",
//                     "Ui Kits": "Kits de UI",
//                     "Dropdown": "Dropdown",
//                     "Accordion": "Acordeão",
//                     "Tabs": "Abas",
//                     "Lists": "Listas",
//                     "Divider": "Divisor",
//                     "Placeholders": "Espaços reservados",
//                     "Offcanvas": "Fora da tela",
//                     "Navigate": "Navegar",
//                     "Ratios": "Proporções",
//                     "Bonus Ui": "UI Bônus",
//                     "Scrollable": "Rolável",
//                     "Tree View": "Visualização de Árvore",
//                     "Toasts": "Toasts",
//                     "Rating": "Avaliação",
//                     "Dropzone": "Dropzone",
//                     "Tour": "Tour",
//                     "SweetAlert2": "SweetAlert2",
//                     "Carousel": "Carrossel",
//                     "Ribbons": "Fitas",
//                     "Pagination": "Paginação",
//                     "Breadcrumb": "Breadcrumb",
//                     "Range Slider": "Slider de Faixa",
//                     "Image Cropper": "Cortador de Imagem",
//                     "Basic Card": "Cartão Básico",
//                     "Creative Card": "Cartão Criativo",
//                     "Timeline": "Linha do Tempo",
//                     "Icons": "Ícones",
//                     "Flag Icon": "Ícone de Bandeira",
//                     "Fontawesome Icon": "Ícone Fontawesome",
//                     "Ico Icon": "Ícone Ico",
//                     "Themify Icon": "Ícone Themify",
//                     "Feather Icon": "Ícone Feather",
//                     "Weather Icon": "Ícone do Tempo",
//                     "Buttons": "Botões",
//                     "Default Style": "Estilo Padrão",
//                     "Button Group": "Grupo de Botões",
//                     "Charts": "Gráficos",
//                     "Apex Chart": "Gráfico Apex",
//                     "Google Chart": "Gráfico Google",
//                     "Chartjs Chart": "Gráfico Chart JS",
//                     "Pages": "Páginas",
//                     "Sample Page": "Página de Exemplo",
//                     "Others": "Outros",
//                     "Error Page": "Páginas de Erro",
//                     "Error 400": "Erro 400",
//                     "Error 401": "Erro 401",
//                     "Error 403": "Erro 403",
//                     "Error 404": "Erro 404",
//                     "Error 500": "Erro 500",
//                     "Error 503": "Erro 503",
//                     "Login Simple": "Login Simples",
//                     "Login with Bg Image": "Login com Imagem de Fundo",
//                     "Login With Image Two": "Login com Duas Imagens",
//                     "Login With Validation": "Login com Validação",
//                     "Login With Tooltip": "Login com Tooltip",
//                     "Login With Sweetalert": "Login com Sweetalert",
//                     "Register Simple": "Registro Simples",
//                     "Register With Bg Image": "Registro com Imagem de Fundo",
//                     "Register With Bg Two": "Registro com Duas Imagens",
//                     "Register Wizard": "Assistente de Registro",
//                     "Unlock User": "Desbloquear Usuário",
//                     "Forget Password": "Esqueci a Senha",
//                     "Reset Password": "Redefinir Senha",
//                     "Maintenance": "Manutenção",
//                     "Coming Simple": "Em Breve Simples",
//                     "Coming With Bg Video": "Em Breve com Vídeo de Fundo",
//                     "Coming With Bg Image": "Em Breve com Imagem de Fundo",
//                     "Miscellaneous": "Diversos",
//                     "Gallery": "Galeria",
//                     "Gallery Grid": "Grade da Galeria",
//                     "Gallery Grid Desc": "Descrição da Grade na Galeria",
//                     "Masonry Gallery": "Galeria de Alvenaria",
//                     "Masonry With Desc": "Alvenaria com Descrição",
//                     "Hover Effects": "Efeitos de Hover",
//                     "Blog": "Blog",
//                     "Blog Grids": "Grade do Blog",
//                     "Blog Details": "Detalhes do Blog",
//                     "Blog Single": "Postagem Única do Blog",
//                     "Add Post": "Adicionar Postagem",
//                     "FAQ": "Perguntas Frequentes",
//                     "Job Search": "Busca de Emprego",
//                     "Cards View": "Visualização de Cartões",
//                     "List View": "Visualização de Lista",
//                     "Job Details": "Detalhes do Trabalho",
//                     "Apply": "Aplicar",
//                     "Learning": "Aprendizado",
//                     "Learning List": "Lista de Aprendizado",
//                     "Detailed Course": "Curso Detalhado",
//                     "Maps": "Mapas",
//                     "Google Maps": "Google Maps",
//                     "Leaflet Maps": "Mapas Leaflet",
//                     "Editors": "Editores",
//                     "Ck Editor": "Editor Ck",
//                     "MDE Editor": "Editor MDE",
//                     "ACE Code Editor": "Editor de Código ACE",
//                     "Quill Editor": "Editor Quill",
//                     "ACE Editor": "Editor ACE",
//                     "Knowledgebase": "Base de Conhecimento",
//                     "Support Ticket": "Ticket de Suporte",
//                     "Authentication": "Autenticação",
//                     "Login With Bg Image": "Login com Imagem de Fundo",
//                     "Pinned": "Fixado",
//                     "Coming Soon": "Em Breve"
//                 },                
//             },
//         },
//         fallbackLng: "en",
//         debug: false,
//         ns: ["translations"],
//         defaultNS: "translations",
//         keySeparator: false,
//         interpolation: {
//             escapeValue: false,
//         },
//     });

// export default i18n;